import { DashboardProject } from "@api/apiClient";
import { useDashboardProjects } from "@api/projects";
import useAppStore from "@hooks/useAppStore";
import i18n from "@i18n/i18n";
import { Grid, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";

const DashboardTiles = observer((props: any) => {
  const appStore = useAppStore();
  const theme = useTheme();
  const navigate = useNavigate();
  const { data } = props;
  const dashboardProjects = useDashboardProjects();

  return (
    <Grid mt={2} container spacing={2}>
      {data?.map((project: DashboardProject) => (
        <Grid key={project.projectId}>
          <Card>
            <Box
              sx={{
                cursor: "pointer",
                width: "300px",
              }}
              onClick={() => {
                navigate(`/projects/${project.projectId}`);
              }}
            >
              {project?.imageUrl && <Box component="img" src={project?.imageUrl} width="100%" height="150px" alt="" sx={{ objectFit: "cover" }} />}
              {!project?.imageUrl && <Box component="img" src="/img/img-placeholder-1x.png" width="100%" height="150px" alt="" sx={{ objectFit: "contain" }} />}
              <Box p={1}>
                <Typography variant="subtitle1" sx={{ fontWeight: theme.typography.fontWeightBold }}>
                  {project.name}
                </Typography>
                <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
                  {i18n.t("dashboard.message.model-count", { count: Number(project?.modelCount) })}
                </Typography>
              </Box>
            </Box>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
});

export default DashboardTiles;
